"use strict";

angular.module("core")
.component("mpttViewer", {
    templateUrl: require("./mptt-viewer.component.html"),
    bindings: {
        labelText: "<",
        selectedElement: "=?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/mptt-viewer/mptt-viewer.component.js
// module id = 552
// module chunks = 0